import { useStore } from 'effector-react'
import * as React from 'react'

import { $dividendEvent, dividendEventMounted, getDividendEvent } from './model'

export const useDividendEvent = () => {
  const dividendEvent = useStore($dividendEvent)
  const loading = useStore(getDividendEvent.pending)

  React.useEffect(() => {
    dividendEventMounted()
  }, [])

  return { dividendEvent, loading }
}
